import { render, staticRenderFns } from "./SIFDEInformation.vue?vue&type=template&id=9322ff06&scoped=true"
import script from "./SIFDEInformation.vue?vue&type=script&lang=js"
export * from "./SIFDEInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9322ff06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9322ff06')) {
      api.createRecord('9322ff06', component.options)
    } else {
      api.reload('9322ff06', component.options)
    }
    module.hot.accept("./SIFDEInformation.vue?vue&type=template&id=9322ff06&scoped=true", function () {
      api.rerender('9322ff06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/contract/components/SIFDE/SIFDEInformation.vue"
export default component.exports